// AuthContext.jsx

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { useHistory, useLocation } from "react-router-dom";

const { readCookie } = require("../Functions/Cookies.js");

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const moveToLogin = useCallback(() => {
    console.log("Redirecting to login...");
    history.push("/login");
  }, [history]);

  const clearAuth = useCallback(() => {
    window.localStorage.clear();
  }, []);

  const validate = useCallback(async () => {
    try {
      console.log("starting validation function...");

      const auth = localStorage.getItem("auth");

      if (!auth) {
        console.log("No token found");
        moveToLogin();
        return;
      }

      const { token, sessionId } = JSON.parse(auth) || {};

      const response = await fetch(
        `${process.env.REACT_APP_ORIGIN}/api/v1/auth/validate/${token}`,
      );

      const data = await response.json();

      console.log("token validation response->", data);

      if (data.status === "authorized") {
        const authUser = data.data.user;

        setUser(authUser);

        const id = authUser.userId;
        const role = authUser.role;
        const path = `/session/${sessionId}/user/${id}`;
        if (role === "student") {
          console.log(`${process.env.REACT_APP_STUDENT}${path}`);
          window.location.href = `${process.env.REACT_APP_STUDENT}/auth/${token}/${id}`;
        } else if (role === "teacher" || role === "principal") {
          console.log(`${process.env.REACT_APP_TEACHER}${path}`);
          window.location.href = `${process.env.REACT_APP_TEACHER}${path}`;
        } else {
          console.log(
            `${process.env.REACT_APP_SCHOOL_ADMIN}/auth/${token}/${id}`,
          );
          window.location.href = `${process.env.REACT_APP_SCHOOL_ADMIN}/auth/${token}/${id}`;
        }
      } else {
        clearAuth();
        moveToLogin();
      }
    } catch (error) {
      console.log("Validation error:", error);

      clearAuth();

      moveToLogin();
    } finally {
      setLoading(false);
    }
  }, [clearAuth, moveToLogin]);

  const logout = useCallback(() => {
    clearAuth();
    setUser(null);
    moveToLogin();
  }, [clearAuth, moveToLogin]);

  useEffect(() => {
    const loggedOut =
      new URLSearchParams(location.search).get("logout") || false;

    if (loggedOut) {
      logout();
      moveToLogin();
      return;
    }

    validate();
  }, [location.search, logout, validate]);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        validate,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
